import React from 'react'

export const Assembler = ({ component }) => component

export const Edit = ({ children }) => <div>{children}</div>
